<template>
  <div class="pt-10">
    <div class="px-5">
      <Sidebar></Sidebar>
      <Header>{{ $t('all.scanner_qr_code') }}</Header>
      <div v-if="!isError" class="text-center pb-4 pt-4">
        <p class="text-blue-dark  text-sm leading-normal">
          {{ $t('all.scan_qr_code_of') }}
          <span class="text-red"> {{ minorName }}</span>
          {{ $t('all.to_mark_presence') }}
        </p>
      </div>
      <div v-if="isError" class="pb-4 pt-4 text-center">
        <h1 class="text-red"> {{ $t('all.ops') }} </h1>
        <p class="text-blue-dark text-sm">{{
          $t('all.something_went_wrong')
        }}</p>
        <p class="text-blue-dark"> {{ errorMessage }} </p>
      </div>
      <div class="flex justify-center" v-if="!opencamera">
        <img src="/img/SCAN.png" class="w-48 h-48" />
      </div>
      <div class="flex justify-center">
        <h4
          v-if="!opencamera || isError"
          @click="openCamera"
          class="text-center uppercase text-10px block rounded-full w-2/5 my-2 py-3 px-6 bg-red text-white hover:text-white align-middle"
        >
          {{ $t('all.scan') }}
        </h4>
        <div v-if="opencamera" class="w-3/4">
          <qrcode-stream
            @decode="onDecode"
            :paused="!camera"
            :camera="cameraSetup"
            @init="onInit"
          >
          </qrcode-stream>
        </div>
      </div>
      <div class="flex justify-center pt-4" v-if="loading">
        <p class="text-blue-dark text-center text-sm">{{
          $t('all.close_camera_to_qr_code')
        }}</p>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import { authService } from '@/services';
import { mapActions } from 'vuex';

export default {
  name: 'QrCode',
  data() {
    return {
      opencamera: false,
      camera: true,
      minor: null,
      isError: false,
      errorMessage: null,
      loading: false,
      cameraSetup: {
        width: { min: 640, ideal: 640, max: 1280 }, // constrain video width resolution
        height: { min: 480, ideal: 480, max: 720 }, // constrain video height resolution
      },
    };
  },
  computed: {
    minorName() {
      return this.$route.query.fullname;
    },
  },
  methods: {
    ...mapActions('minor', ['qrScan']),
    ...mapActions('users', ['getMinor']),
    ...mapActions('authentication', ['getUserInfo']),
    async onDecode(decodedString) {
      this.camera = false;
      this.minor = this.$store.state.users.detail.minor;
      const minor_id = this.minor.id;
      const institute_id = parseInt(decodedString);
      try {
        const response = await this.qrScan({ minor_id, institute_id });
        this.loading = false;
        this.$router.replace({
          name: 'QrCodeSuccess',
          query: { action: response },
        });
      } catch (error) {
        this.isError = true;
        this.camera = false;
        this.opencamera = false;
        this.loading = false;
      }
    },
    openCamera() {
      this.opencamera = true;
      this.isError = false;
      this.camera = true;
      this.loading = true;
    },
    getRole(role) {
      return authService.hasRole(role);
    },
    async onInit(promise) {
      // show loading indicator
      this.loading = true;
      try {
        await promise;

        // successfully initialized
      } catch (error) {
        if (error.name === 'NotAllowedError') {
          // user denied camera access permisson
          this.errorMessage = `${this.$t('all.errorScanMessage')}`;
        } else if (error.name === 'NotFoundError') {
          this.errorMessage = `${this.$t('all.errorScanMessage')}`;
          // no suitable camera device installed
        } else if (error.name === 'NotSupportedError') {
          this.errorMessage = `${this.$t('all.errorScanMessage')}`;
          // page is not served over HTTPS (or localhost)
        } else if (error.name === 'NotReadableError') {
          // maybe camera is already in use
          this.errorMessage = `${this.$t('all.errorScanMessage')}`;
        } else if (error.name === 'OverconstrainedError') {
          this.errorMessage = `${this.$t('all.errorScanMessage')}`;
          // passed constraints don't match any camera.
          // Did you requested the front camera although there is none?
        } else if (error.name === 'StreamApiNotSupportedError') {
          this.errorMessage = `${this.$t('all.errorScanMessage')}`;
          // browser seems to be lacking features
        }
      } finally {
        // hide loading indicator
        this.loading = false;
      }
    },
  },
  async created() {
    await this.getUserInfo();
    const role = authService.getRole();
    const id = this.$route.params.id;
    await this.getMinor({ id, role });
  },
};
</script>
